import { useNotify } from "react-admin";
import { Button, Stack } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import MapIcon from "@mui/icons-material/Map";
import { gmapsQueryUrl, joinAddressLine } from "../components/raFormat";

function stop(e: React.SyntheticEvent) {
  e.preventDefault(); // prevents ReferenceField link default navigation
  e.stopPropagation(); // prevents bubbling to ReferenceField
}

export function ConstructionSiteQuickActions({
  address,
}: {
  address?: any | null;
}) {
  const notify = useNotify();
  if (!address) return null;

  const line = joinAddressLine(address);
  const mapUrl = gmapsQueryUrl(address);

  return (
    <Stack direction="row" spacing={1}>
      <Button
        size="small"
        variant="outlined"
        startIcon={<ContentCopyIcon />}
        onMouseDown={stop}
        onClick={async (e) => {
          stop(e);
          await navigator.clipboard.writeText(line);
          notify("Adresse kopiert", { type: "info" });
        }}
      >
        Kopieren
      </Button>

      <Button
        size="small"
        variant="outlined"
        startIcon={<MapIcon />}
        onMouseDown={stop}
        onClick={(e) => {
          stop(e);
          window.open(mapUrl, "_blank", "noopener,noreferrer");
        }}
      >
        Karte
      </Button>
    </Stack>
  );
}
